export default "__VITE_ASSET__Bkzazpt$__"